// filepath: /src/App.js
import React from 'react';
import FrostedGlassMenu from './components/FrostedGlassMenu';
import Footer from './components/Footer';
import HeroSection from './sections/HeroSection';
import AboutUsSection from './sections/AboutUsSection';
import FeaturesSection from './sections/FeaturesSection';
import GallerySection from './sections/GallerySection'; 
import LicenseSection from './sections/LicenseSection';
import InvitationSection from './sections/InvitationSection'; 
import SystemAccessSection from './sections/SystemAccessSection';
import ContactSection from './sections/ContactSection';
import MaintenanceOverlay from './components/MaintenanceOverlay';
import './styles/App.css';

function App() {
  // ===== CONTROL DE MANTENIMIENTO =====
  // Cambia a false para desactivar el overlay de mantenimiento
  const MAINTENANCE_MODE = false;
  
  return (
    <>
      {/* Overlay de mantenimiento - bloquea toda la funcionalidad */}
      <MaintenanceOverlay isActive={MAINTENANCE_MODE} />
      
      <FrostedGlassMenu />
      <main>
        <HeroSection />
        <AboutUsSection />
        <FeaturesSection />
        <GallerySection /> 
        <LicenseSection />
        <InvitationSection />
        <SystemAccessSection />
        <ContactSection />
      </main>
      <Footer />
    </>
  );
}

export default App;
